import IconSuccess from '@/assets/Icon/svg/Success';
import IconWarning from '@/assets/Icon/svg/Warning';
import IconError from '@/assets/Icon/svg/Error';

export const ALERT_TYPES = ['default', 'info', 'success', 'caution', 'error'];
export const POSITIONS = ['right', 'left'];

export const DEFAULT_ALERT_ICONS = {
  success: IconSuccess,
  caution: IconWarning,
  error: IconError,
};
